import React from "react";

function Footer() {
  return (
    <div className="footer-div">
      <div className="row text-center">
        <div className="col-lg-4 col-md-4 col-sm-12 col-12"></div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-12 text-center mt-4">
          <a href="mailto:cbirmole@gmail.com">
            <i class="footer-icons fab far fa-envelope"></i>
          </a>
          <a href="https://www.instagram.com/chetas11/?hl=en">
            <i class="footer-icons fab fa-instagram"></i>
          </a>
          <a href="https://github.com/chetas11">
            <i class="footer-icons fab fa-github-alt"></i>
          </a>
          <a href="https://www.linkedin.com/in/chetan-b-5aa977b1/">
            <i class="footer-icons fab fa-linkedin"></i>
          </a>
        </div>
        <div className="col-lg-4 col-md-4 col-sm-12 col-12"></div>
        <h6 className="mt-4" style={{ color: "#929aab" }}>
          © 2021 Chetan Birmole.
        </h6>
      </div>
    </div>
  );
}

export default Footer;
